import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useQuery } from '@apollo/client';

import { put } from '@general/api/shared';
import { PROFILE_PHOTO_URLS_QUERY } from '@general/graphql/viewer.graph';

const useSaveImageS3 = ({ onSuccessCropped, onErrorCropped }) => {
    const [loadingSignedUrls, setLoadingSignedUrls] = useState(true);
    // const getSignedUrls = useImperativeQuery(PROFILE_PHOTO_URLS_QUERY);
    // needs to do a fresh request on mount - so don't keep it in the cache
    // poll starts when component is mounted
    const { loading, error, data } = useQuery(PROFILE_PHOTO_URLS_QUERY, {
        // 4 min, url expires every 5
        pollInterval: 1000 * 60 * 4,
        fetchPolicy: 'no-cache',
        onCompleted: () => {
            setLoadingSignedUrls(false);
        },
    });

    const [loadingFull, setLoadingFull] = useState(false);
    const [errorFull, setErrorFull] = useState(false);
    const [loadingCropped, setLoadingCropped] = useState(false);
    const [errorCropped, setErrorCropped] = useState(false);

    const saveImage = async (signedUrl, image) =>
        // cropped or Full depending on signedUrl
        put({
            url: signedUrl,
            data: image,
            headers: { 'content-type': 'application/octet-stream' },
        });

    const saveImageFull = async image => {
        setLoadingFull(true);
        setErrorFull(null);

        try {
            await saveImage(data.profilePhotoUploadUrls.full, image);
            setLoadingFull(false);
            return data.profilePhotoUploadUrls.full.split('?')[0];
        } catch (e) {
            setLoadingFull(false);
            setErrorFull(e);
            // stop save of cropped image
            throw new Error('Error saving full image');
        }
    };

    const saveImageCropped = async image => {
        setLoadingCropped(true);
        try {
            await saveImage(data.profilePhotoUploadUrls.cropped, image);
            setLoadingCropped(false);
            if (onSuccessCropped) {
                onSuccessCropped();
            }
            return data.profilePhotoUploadUrls.cropped.split('?')[0];
        } catch (e) {
            setLoadingCropped(false);
            setErrorCropped(e);
            if (onErrorCropped) {
                onErrorCropped();
            }
        }
    };

    return { loadingSignedUrls, loadingFull, saveImageFull, errorFull, loadingCropped, saveImageCropped, errorCropped };
};

useSaveImageS3.propTypes = {
    onSuccessCropped: PropTypes.func,
    onErrorCropped: PropTypes.func,
};

export default useSaveImageS3;
